import '../../rules-table.css';
import { useAppDispatch } from 'hooks';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Modal, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { getBurnerFilters } from '../../reducers/selectors';
import { CDBurnerFilter } from 'reducers/burnerFiltersReducer';
import CDBurnerFilterModal from './CDBurnerFilterModal';
import * as cdBurnfiltersActions from '../../actions/burnerFiltersActions';
import CDBurnerFilterRow from './CDBurnerFilterRow';
import * as http from '../../http';

const CDBurnerFiltersPage = () => {
  const dispatch = useAppDispatch();
  const filters: CDBurnerFilter[] = useSelector(getBurnerFilters);
  const [editingFilter, setEditingFilter] = useState<CDBurnerFilter | undefined>(undefined);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [deletingFilter, setDeletingFilter] = useState<CDBurnerFilter | undefined>(undefined);
  const toaster = {
    success: message => dispatch({ type: 'SUCCESS', message }),
    info: message => dispatch({ type: 'INFO', message }),
    warning: message => dispatch({ type: 'WARNING', message }),
    error: message => dispatch({ type: 'ERROR', message }),
  };

  const handleCloseModal = () => {
    setEditingFilter(undefined);
    setShowModal(false);
  };
  const handleShowModal = (filter: CDBurnerFilter | undefined) => {
    setEditingFilter(filter);
    setShowModal(true);
  };

  useEffect(() => {
    dispatch(cdBurnfiltersActions.getFilters());
  }, [dispatch]);

  return (
    <Card className="page-panel-common">
      <Card.Body>
        <h3>CD burner filters</h3>
        <Col>
          <Row style={{ placeContent: 'end' }}>
            <Button onClick={() => handleShowModal(undefined)} className="align-self-end" size="sm" variant="primary">
              Add filter
            </Button>
          </Row>
          <Row>
            <table className="rules-table">
              <thead>
                <tr>
                  <th>Tag</th>
                  <th>Condition</th>
                  <th>Value</th>
                  <th>Enabled</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filters &&
                  filters.map(filter => {
                    return (
                      <CDBurnerFilterRow
                        key={filter.pk + filter.filterTag}
                        filter={filter}
                        showModal={handleShowModal}
                        setDeletingFilter={setDeletingFilter}
                      />
                    );
                  })}
              </tbody>
            </table>
          </Row>
        </Col>
      </Card.Body>
      {deletingFilter && (
        <DeleteBurnerFilterPopup
          burnerFilter={deletingFilter!}
          onClose={() => setDeletingFilter(undefined)}
          onConfirmDelete={() => {
            http
              .del(`/rest/react/cd-burner-filters/${deletingFilter.pk}`)
              .then(res => {
                dispatch(cdBurnfiltersActions.getFilters());
                toaster.success(`Successfully deleted CD print filter`);
                setDeletingFilter(undefined);
              })
              .catch(e => toaster.error(e.message));
          }}
        />
      )}
      {showModal && (
        <CDBurnerFilterModal
          editMode={editingFilter !== undefined}
          filter={editingFilter}
          show={showModal}
          handleClose={handleCloseModal}
        />
      )}
    </Card>
  );
};

const DeleteBurnerFilterPopup = ({ burnerFilter, onClose, onConfirmDelete }) => (
  <Modal show>
    <Modal.Header>
      <Modal.Title>Deleting CD burner filter</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        Deleting CD burner filter configured with dicom tag <i>{burnerFilter.filterTag}</i>, condition{' '}
        <i>{burnerFilter.filterCondition.replaceAll('_', ' ')}</i> value <i>{'"' + burnerFilter.filterValue + '"'}</i>
      </p>
      <p>Are you sure?</p>
    </Modal.Body>
    <Modal.Footer>
      <div style={{ textAlign: 'right' }}>
        <Button onClick={onClose} variant="outline-secondary" style={{ marginRight: '5px' }}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirmDelete}>
          Confirm delete
        </Button>
      </div>
    </Modal.Footer>
  </Modal>
);

export default CDBurnerFiltersPage;
